import Button from '@atlaskit/button/standard-button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { HostingDisplayName } from '@atlassian/mpac-types';
import { MarketplacePricingTierModeValues, MarketplacePricingTierTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import last from 'lodash/last';
import React, { useState } from 'react';
import { ANALYTICS_EVENT_CONTAINER_PRICING_TAB, ANALYTICS_SUBJECT_ID_ADDITIONAL_PRICING_EXAMPLE } from "../../../../../analytics/Events";
import { TEST_ID } from "../../../../../constants";
import { MAX_INITIAL_TIERS_TO_DISPLAY, VIEW_ADDITIONAL_PRICING_DETAILS, VIEW_ADDITIONAL_PRICING_EXAMPLES } from "../PricingTab.constants";
import { PricingDescription as Description } from "../PricingTab.styles";
import PricingGrid from "./PricingGrid";
import PricingTable from "./PricingTable";
import { AdditionalPricingSectionWithBorder, PricingTiersContainer } from "./PricingTiers.styles";
export const AdditionalTiersLabel = props => {
  const {
    hasAdditionalTiers,
    finalTier,
    tierType
  } = props;
  if (!hasAdditionalTiers) return null;
  const {
    floor,
    ceiling
  } = finalTier;

  if (tierType === MarketplacePricingTierTypeValues.RemoteAgentTiered) {
    return /*#__PURE__*/React.createElement("strong", null, floor, "+ agents?");
  }

  return ceiling ? /*#__PURE__*/React.createElement("strong", null, ceiling, "+ users?") : null;
};

const PricingTiers = ({
  hosting,
  pricingPlan,
  applicableBillingCycle
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    tieredPricing: {
      items,
      tierType,
      tiersMode
    },
    currency
  } = pricingPlan;

  const closeModal = () => setModalIsOpen(false);

  const openModal = event => {
    const {
      target
    } = event;

    if (target instanceof window.Element) {
      fireAnalyticsEvent({
        eventType: LinkClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_ADDITIONAL_PRICING_EXAMPLE,
        attributes: {
          eventContainer: ANALYTICS_EVENT_CONTAINER_PRICING_TAB,
          label: tiersMode === MarketplacePricingTierModeValues.Graduated ? VIEW_ADDITIONAL_PRICING_EXAMPLES : VIEW_ADDITIONAL_PRICING_DETAILS
        }
      });
    }

    setModalIsOpen(true);
  };

  const tiers = items.slice(0, MAX_INITIAL_TIERS_TO_DISPLAY);
  const hasAdditionalTiers = items.length > tiers.length;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Description, null, "Free for 30 days for teams of all sizes."), /*#__PURE__*/React.createElement(PricingTiersContainer, null, /*#__PURE__*/React.createElement(PricingGrid, {
    items: tiers,
    currency: currency,
    tierType: tierType
  }), hasAdditionalTiers && /*#__PURE__*/React.createElement(AdditionalPricingSectionWithBorder, null, /*#__PURE__*/React.createElement(AdditionalTiersLabel, {
    hasAdditionalTiers: hasAdditionalTiers,
    finalTier: last(tiers),
    tierType: tierType
  }), /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    onClick: openModal,
    testId: TEST_ID.PRICING_TAB_VIEW_ADDITIONAL_PRICING
  }, tiersMode === MarketplacePricingTierModeValues.Graduated ? VIEW_ADDITIONAL_PRICING_EXAMPLES : VIEW_ADDITIONAL_PRICING_DETAILS))), hasAdditionalTiers && /*#__PURE__*/React.createElement(ModalTransition, null, modalIsOpen && /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    width: "small"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, "".concat(HostingDisplayName[hosting], " Pricing"))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(PricingTable, {
    currency: currency,
    items: items,
    tierType: tierType,
    hosting: hosting,
    billingCycle: applicableBillingCycle
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: closeModal
  }, "Close")))));
};

export default PricingTiers;